$(function(){
    $('.nav_our_work').on('click', queryPosts);
    window.addEventListener('scroll', () => {
        const {
            scrollTop,
            scrollHeight,
            clientHeight
        } = document.documentElement;
    
        if (scrollTop + clientHeight >= scrollHeight - 5) {
            queryInfiniteNextPost();
        }
    }, {
        passive: true
    });
});

function queryPosts() {
    var $this = $(this);
    $this.addClass('active');
    window.history.pushState("Our Work", "Our Work", "/our-work");
    const data = new FormData();
    data.append("action", 'wpkai/post');
    data.append("type", ['work', 'advertisement']);
    data.append("quantity", window.wpkai_config.posts_per_page);
    data.append("paged", 1);

    fetch(wpkai_config.api_endpoint, {
        method: "POST",
        body: data,
    })
    .then((response) => response.json())
    .then((response) => {
        window.wpkai_query_info = response.query;
        window.wpkai_query_pagination = response.pagination;
        return response.posts.map(buildBox);
    })
    .then((boxes) => {
        $boxes = $(boxes);
        window.$grid.masonry('remove', $('.grid-item'));
        window.$grid.append($boxes).masonry('appended', $boxes);
        window.$grid.masonry('layout');
        window.bindBoxZIndex();
        window.attachMobileGrowEffectOnBoxes();
    });
}

function queryInfiniteNextPost() {
    if (window.wpkai_query_in_process == undefined) {
        window.wpkai_query_in_process = false;
    }
    if (!window.wpkai_query_pagination)  return;
    if (!window.wpkai_query_info)  return;
    if (!window.wpkai_query_pagination.next)  return;
    if (window.wpkai_query_in_process)  return;
    

    const data = new FormData();
    data.append("action", 'wpkai/post');
    data.append("category", window.wpkai_query_info.category);
    data.append("quantity", window.wpkai_query_info.quantity);
    data.append("paged", window.wpkai_query_pagination.next);
    data.append('metakey', 'work_order');
    data.append('orderby', 'meta_value_num');
    data.append('order', 'DESC');
    
    window.wpkai_query_in_process = true;
    fetch(wpkai_config.api_endpoint, {
        method: "POST",
        body: data,
    })
    .then((response) => response.json())
    .then((response) => {
        window.wpkai_query_info = response.query;
        window.wpkai_query_pagination = response.pagination;
        window.wpkai_query_in_process = false;
        return response.posts.map(buildBox);
    })
    .then((boxes) => {
        $boxes = $(boxes).css('opacity', "0.0");
        window.$grid.append($boxes).show('slow').masonry('appended', $boxes);
        window.bindBoxZIndex();
        window.attachMobileGrowEffectOnBoxes();
    });
}

function buildBox($data){
    var href = '';
    if ($data.meta && $data.meta._dieste_featured_ad != 'yes') {
        href = 'href="' + $data.link + '"';
    }
    console.log($data);
    var box = `
    <div class="grid-item ${$data.meta._dieste_hover_rise || ''} ${$data.meta._dieste_box_size || ''}">
        <div class="post-border"></div>
        <div class="post-fill"></div>
        <div class="post-content">
            <a ${$data.external ? $data.external : ''} ${href}>
                <div class="backdrop-shadow" ${$data.meta._dieste_box_dropshadow && $data.meta._dieste_box_dropshadow.size !== undefined ? 'style="opacity: ' + $data.meta._dieste_box_dropshadow.size + '%;"' : ''}></div>
                <div class="post-thumbnail" style="--thumbnail: url('${$data.meta._dieste_thumbnail_desktop && $data.meta._dieste_thumbnail_desktop.url ? $data.meta._dieste_thumbnail_desktop.url : $data.thumbnail}'); --thumbnail-mobile: url('${$data.meta._dieste_thumbnail_mobile && $data.meta._dieste_thumbnail_mobile.url ? $data.meta._dieste_thumbnail_mobile.url : $data.thumbnail}'); --thumbnail-tablet: url('${$data.meta._dieste_thumbnail_tablet && $data.meta._dieste_thumbnail_tablet.url ? $data.meta._dieste_thumbnail_tablet.url : $data.thumbnail}');"> </div>
                <div class="post-title">
                    ${!$data.meta._dieste_featured_hide_title || $data.meta._dieste_featured_hide_title == 'false' ? '<h3>' + $data.title + '</h3>' : ''}
    `;
    if (!$data.meta._dieste_featured_hide_excerpt) {
        box += `<div class="post-subtitle">`;
        if ($data.meta._dieste_client_name) {
            box += `
            <span class="post-client-name">${$data.meta._dieste_client_name}</span>
            <span class="post-subtitle-divider">·</span>
            `;
        }
        box += ` <span class="post-type">${$data.type}</span> </div> `;
    }     
    box += `               
                </div>
            </a>
        </div>
    </div>`;

    var el = document.createElement('div');
    el.innerHTML = box.trim();

    return el.firstElementChild;
}